module.exports = __webpack_public_path__ + "img/signal2.b38486d6.svg";